import { fitIn } from "@/utils/imageHandler";
import Image from "next/image";
import Link from "next/link";
import React from "react";

export default function RelatedReport({ connectedWith, relatedItems }) {
  // Case 1: single report
  if (connectedWith) {
    return (
      <div>
        <h2 className='pb-2 mb-4 text-lg font-semibold border-b border-white/10'>
          Related Report
        </h2>
        <Link
          href={`/reports/${connectedWith.slug}`}
          className='relative flex items-start space-x-6 group'
        >
          <div className='flex-1'>
            <p className='mb-2 text-base font-semibold leading-tight tracking-tight text-white group-hover:underline lg:leading-tight'>
              {connectedWith.title}
            </p>
            <p className='text-xs leading-normal text-white/40 line-clamp-3'>
              {connectedWith.excerpt}
            </p>
          </div>
          <div className='w-20 relative aspect-[3/4] rounded overflow-hidden border border-white/10'>
            <Image
              src={fitIn(connectedWith.cover_image_url, 600)}
              layout='fill'
              objectFit='cover'
              alt={connectedWith.cover_image_alt}
            />
          </div>
        </Link>
      </div>
    );
  }

  // Case 2: multiple reports
  if (relatedItems?.length > 0) {
    return (
      <div>
        <h2 className='pb-2 mb-4 text-lg font-semibold border-b border-white/10'>
          Special Reports
        </h2>
        <div className='-my-3 divide-y divide-white/10 divide-dashed'>
          {relatedItems.map((report, index) => (
            <Link
              href={`/reports/${report.slug}`}
              className='relative flex items-start py-3 space-x-6 group'
              key={`related-report-${index}`}
            >
              <div className='flex-1'>
                <p className='mb-2 text-base font-semibold leading-tight tracking-tight text-white group-hover:underline lg:leading-tight'>
                  {report.title}
                </p>
                <p className='text-xs leading-normal text-white/40 line-clamp-3'>
                  {report.excerpt}
                </p>
              </div>
              <div className='w-20 relative aspect-[3/4] rounded overflow-hidden border border-white/10'>
                <Image
                  src={fitIn(report.cover_image_url, 600)}
                  layout='fill'
                  objectFit='cover'
                  alt={report.cover_image_alt || ""}
                />
              </div>
            </Link>
          ))}
        </div>
      </div>
    );
  }

  return null;
}
